import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isAuthenticated: boolean;
  user: Record<string, any> | null;
  authStatus: Record<string, any> | null;
  token: string | null
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  authStatus: null,
  token: null

};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setUser: (state, action: PayloadAction<Record<string, any> | null>) => {
      state.user = action.payload;
    },
    setAuthStatus: (
      state,
      action: PayloadAction<Record<string, any> | null>
    ) => {
      state.authStatus = action.payload;
    },
    setAuthenticateUser: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
  },
});

export const { setUser, setIsAuthenticated, setAuthStatus, setAuthenticateUser } = authSlice.actions;

export default authSlice.reducer;
